const LANGUAGE_OPTIONS = [
  'Amharic',
  'Arabic',
  'ASL',
  'Bengali',
  'Burmese',
  'Chinese (Cantonese)',
  'Chinese (Mandarin)',
  'Chuukese',
  'Dari',
  'Dzongkha',
  'English',
  'Farsi',
  'French',
  'Fulani (Guinean)',
  'Fullar',
  'German',
  'Guerze (Guinean)',
  'Gujarati',
  'Haitian Creole',
  'Hausa',
  'Hindi',
  'Hmong',
  'Indonesian',
  'Italian',
  'Japanese',
  'Karen',
  'Khmer',
  'Kinande',
  'Kinyarwanda',
  'Kirundi',
  'Kissi',
  'Kissi (Guinean)',
  'Kono',
  'Korean',
  'Krio',
  'Kurdish',
  'Lao',
  'Limba',
  'Luganda',
  'Madingo',
  'Malinke',
  'Malinke (Guinean)',
  'Mende',
  'Nepali',
  'Oromo',
  'Pashto',
  'Pohnpeian',
  'Portuguese',
  'Polish',
  'Russian',
  'Samoan',
  'Somali',
  'Sousou (Guinean)',
  'Spanish',
  'Susu',
  'Swahili',
  'Tagalog',
  'Themne',
  'Tigrinya',
  'Toma (Guinean)',
  'Tongan',
  'Turkish',
  'Ukrainian',
  'Urdu',
  'Vietnamese',
  'Wolof',
  'Other language',
];

export default LANGUAGE_OPTIONS;
